<template>
  <div class="col-xl-3 col-lg-6 px-xl-2 px-lg-2 py-1 ml-3">
    <div class="filter-select" :class="{'expanded': expanded===true}" @click.stop="toggleExpand" >
      <span class="filter-title"> {{ filterTitle }} ({{filteredAllChecked ? 'All' : filteredSelectedOptionsLength}})</span>
      <i class="dropdown-icon"></i>
      <div class="dropdown" v-if="expanded">
        <div class="filter-sub-desc p-2" v-if="filterSubDesc">
          {{filterSubDesc}}
        </div>
        <div class="dropdown-option all-option" @click.stop="clickedAllOption()" v-if="!filterGroups">
          <div class="option-name">All</div>
          <input type="checkbox" :checked="allChecked">
        </div>
        <div v-for="(optionGroup, optionGroupIndex) in filterOptions"
             class="dropdown-option" :key="optionGroupIndex"
             @click.stop="clickedOption(optionGroup)"
             :class="isFilterGroupTitle(optionGroup) ? 'group-title':''">
          <div class="option-name">{{optionGroup}} </div>
          <input v-if="!(isFilterGroupTitle(optionGroup))" type="Checkbox" :checked="checkOptionSelected(optionGroup)">
          </div>
        </div>
      </div>
    </div>
</template>

<script>

export default {
  name: "filter-select",
  props: ["filterOptions","filterTitle","savedUserFilter","allOptionsUnchecked","filterSubDesc","isRolesChanged","filterGroups"],
  data() {
    return {
      expanded: false,
      allChecked: true,
      selectedOptions: JSON.parse(JSON.stringify(this.filterOptions)),
      DIRECT_REPORT_STRING: 'Requested by my direct reports',
    };
  },
  watch: {
    selectedOptions(newVal) {
      if(newVal && newVal.length) {
        this.allChecked = this.filterGroups && this.filterGroups.length > 0
            ? newVal.length - this.filterGroups.length === this.filterOptions.length  : newVal.length === this.filterOptions.length
      }
    }
  },
  mounted() {
    document.addEventListener("click", this.onGeneralClick);
    this.getStoredFilters()
  },
  beforeDestroy() {
    document.removeEventListener("click", this.onGeneralClick);
  },
  computed: {
    filteredAllChecked() {
      if(this.filterGroupExists) {
        return this.selectedOptions.length === this.filterOptions.length
      } else return this.allChecked
    },
    filteredSelectedOptionsLength() {
      if(this.filterGroupExists) {
        if(this.savedUserFilterContainsSubGroupTitles())
          return this.savedUserFilter.length - this.filterGroups.length > -1 ? this.savedUserFilter.length - this.filterGroups.length : this.savedUserFilter.length
        else
          return this.savedUserFilter.length
      } else
        return this.selectedOptions.length
    },
    filterGroupExists() {
      return this.filterGroups && this.filterGroups.length > 0
    }
  },
  methods: {
    onGeneralClick() {
      this.expanded = false;
    },
    isFilterGroupTitle(field) {
      return this.filterGroups && this.filterGroups.includes(field)
    },
    toggleExpand() {
      this.expanded = !this.expanded;
    },
    clickedAllOption() {
      this.allChecked = !this.allChecked
      if(this.allChecked) {
        this.markAllSelected()
        this.emitAllOptionsCleared(false)
      } else {
        this.selectedOptions = []
        this.emitAllOptionsCleared(true)
      }
      this.emitOptionsUpdated();
    },
    clickedOption(field) {
      if(!this.isFilterGroupTitle(field)) {
        if (field) {
          var optionIndex = this.selectedOptions.findIndex(selectedOption => {
            return (
                selectedOption == field
            );
          });
          if ((optionIndex == -1 || !optionIndex) && !this.selectedOptions.includes(field)) {
            this.emitAllOptionsCleared(false)
            this.selectedOptions.push(field);
          } else {
            this.selectedOptions.splice(optionIndex, 1);
            if(this.selectedOptions.length === 0) {
              this.emitAllOptionsCleared(true)
              this.allChecked = false
            }
          }
        }
        this.emitOptionsUpdated();
      }
    },
    checkOptionSelected(field) {
      return this.selectedOptions.find(selectedOption => {
        return selectedOption == field
      });
    },

    emitOptionsUpdated() {
      this.$emit("optionsSelected", this.selectedOptions);
    },
    markAllSelected() {
      this.allChecked = true
      this.selectedOptions = JSON.parse(JSON.stringify(this.filterOptions))
      this.emitAllOptionsCleared(false)
      this.emitOptionsUpdated();
    },
    getStoredFilters() {
      if(this.allOptionsUnchecked) {
        this.selectedOptions = []
        this.allChecked = false
        this.emitAllOptionsCleared(true)
      } else {
        if(this.savedUserFilter && this.savedUserFilter.length > 0) {
          if (this.isRolesChanged && this.filterTitle !== this.DIRECT_REPORT_STRING){
            this.selectedOptions = []
            this.filterOptions.forEach(filter => {
              this.clickedOption(filter)
            })
          }else{
            this.selectedOptions = []
            this.savedUserFilter.forEach(filter => {
              this.clickedOption(filter)
            })
          }
        }
      }
    },
    emitAllOptionsCleared(status) {
      let optionsObj = {}
      optionsObj.status = status
      optionsObj.title = this.filterTitle
      this.$emit("allOptionsCleared", optionsObj)
    },
    savedUserFilterContainsSubGroupTitles() {
      return this.filterGroups.every(subDesc => this.savedUserFilter.includes(subDesc))
    }
  }
};
</script>

<style scoped>
.filter-select {
  display: inline-block;
  cursor: pointer;
  word-wrap: break-word;
  line-height: 1.5rem;
  white-space: normal;
  background-color: white;
  width: 100%;
  padding: 6px 10px 6px 10px;
  border-radius: 6px;
  border: 1px solid #c9c9c9;
  font-size: 14px;
  position: relative;
}
.filter-select.expanded {
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
.filter-select:hover {
  border-color: #adadad;
}
.filter-title {
  font-weight: bold;
  color: var(--secondary-color);
}
.dropdown-icon {
  float: right;
  border: solid #2e4258;
  border-width: 0 1.5px 1.5px 0;
  padding: 3px;
  transform: rotate(45deg);
  position: relative;
  right: 2px;
  top: 2px;
}
.dropdown {
  overflow-x: hidden;
  overflow-y: auto;
  backface-visibility: hidden;
  border: 1px solid #c9c9c9;
  border-top-width: 0px;
  outline: none;
  border-radius: 0px 0px 6px 6px;
  max-height: 450px;
  position: absolute;
  top: 100%;
  z-index: 10;
  background-color: white;
  cursor: auto;
  display: block;
  left: 0;
  right: 0;
  width: calc(100% + 2px);
  margin: 0px -1px;
}
.dropdown-option {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  padding: 4px 6px;
  display: flex;
  cursor: pointer;
}
.dropdown-option:hover {
  background-color: #f7f7f7;
}
.dropdown-option:nth-child(even) {
  background-color: #e6f4fb;
}
.dropdown-option:nth-child(even):hover {
  background-color: #cfdfe7;
}
.dropdown-option .option-name {
  width: calc(100% - 20px);
  word-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dropdown-option input {
  width: 20px;
  cursor: pointer;
  margin-top:5px;
}

.all-option {
  font-weight: bold;
  border-bottom: 1.5px solid lightgray;
}

.option-group-title {
  font-weight: bold;
  padding: 4px 6px;
  font-style: italic;
  font-size: 12px;
  color: black;
}

.filter-sub-desc {
  background-color: #f4f7f9!important;
  border-bottom: 1px solid #c9c9c9;
}

.group-title {
  cursor: auto !important;
  font-weight: bold;
  background: #FFFFFF !important;
  border-bottom: 1.5px solid #cbc9c9;
}
</style>
